/*
* show and hide the back in stock notify me button for products
*/
function notifyBackInStock(product) {
  var availableVariants = [];
  var unavailableVariants = [];
  var backInStockElement = $('.bis-' + product.id);
  var addToBagElement = $('.add-to-bag-' + product.id);

  /*
  * The BIS preorder notify me button
  * displayed for the out of stock products
  */
  if (!product.available) {
    backInStockElement.removeClass("hide-element");
  }

  /*
  * Get available and unavailable variants
  */
  product.variants.forEach(function(variant) {
    var sizeSwatch = $("[data-option-name='Size']").find(".panda-swatch[data-value='" + variant.option2 + "']");
    /*
    * Assign data attributes to the size swatch elements
    */
    sizeSwatch.attr("data-variant", variant.id).attr("data-available", variant.available);
    var variantsData = {id: variant.id, available: variant.available};
    return variant.available ? availableVariants.push(variantsData) : unavailableVariants.push(variantsData);
  });

  /*
  * Check if the product is contain 'bis-hidden' tag
  */
  function isBISTag() {
    var isBISTag = false;

    product.tags.forEach(function(hiddenTag) {
      if (!isBISTag && hiddenTag.indexOf("bis-hidden") > -1) {
        isBISTag = true;
      }
    });

    return isBISTag;
  }

  /*
  * Hide the BIS notify me button for 'bis-hidden'
  * tag contained products
  */
  function hiddenBISTag() {
    if (isBISTag()) {
      /*
      * Get the unavailable size variants
      */
      unavailableVariants.forEach(function(variant) {
        var dataVariant = $("[data-variant='" + variant.id + "']").attr("data-bis", "bis-hidden");
        /*
        * Remove the click event for out of stock or
        * the unavailable variants
        */
        dataVariant.attr("disabled", "disabled").unbind("click");
        dataVariant.children().removeClass("cursor");
      });

      addToBagElement.removeClass("hide-element");
      backInStockElement.addClass("hide-element");
    }
  }

  $("[data-variant]").click(function () {
    /*
    * Assign selected variant id
    */
    var variantId = $(this).data("variant");

    /*
    * Get the unavailable size variants
    */
    unavailableVariants.forEach(function(variant) {
      /*
      * If the selected variant id and out of stock or
      * unavailable product variant id is equal then the
      * 'add to bag' element is hidden and bis element is visible
      */
      if (variant.id === variantId && !isBISTag()) {
        addToBagElement.addClass("hide-element");
        backInStockElement.removeClass("hide-element");
        $(".qty-error").addClass("hide-element");
      }
    });

    /*
    * Get the available size variants
    */
    availableVariants.forEach(function(variant) {
      /*
      * If the selected variant id and available
      * product variant id is equal then the
      * 'add to bag' element is visible and bis element is hidden
      */
      if (variant.id === variantId) {
        addToBagElement.removeClass("hide-element");
        backInStockElement.addClass("hide-element");
      }
    });

    /*
    * Pass the selected variant id to the bis email sign up form
    * for pre selected the size
    */
    backInStockElement.find(".BIS_trigger").attr("data-variant-id", variantId);
  });

  hiddenBISTag();
}
